import {
  useTranslate,
  IResourceComponentsProps,
} from "@pankod/refine-core";
import {
  List,
  Table,
  TextField,
  useTable,
  getDefaultSortOrder,
  DateField,
  Space,
  EditButton,
  DeleteButton,
  ShowButton,
} from "@pankod/refine-antd";
import { IEventType } from "interfaces";

export const EventTypeList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();

  const { tableProps, sorter } = useTable<IEventType>({
    initialSorter: [
      {
        field: "event_type_id",
        order: "desc",
      },
    ],
  });

  return (
    <List>
      <Table {...tableProps} rowKey="event_type_id">
        <Table.Column
          dataIndex="event_type_id"
          key="event_type_id"
          title="ID"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("event_type_id", sorter)}
          sorter
        />
        <Table.Column
          dataIndex="name"
          key="name"
          title={t("event_type.fields.name")}
          render={(value) => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title={t("parameter.fields.created_at")}
          render={(value) => <DateField value={value} format="LLL" />}
        />
        <Table.Column<IEventType>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.event_type_id} />
              <ShowButton hideText size="small" recordItemId={record.event_type_id} />
              <DeleteButton hideText size="small" recordItemId={record.event_type_id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
